<template>
    <span></span>
</template>

<script>
    import CountUp from 'countup.js';

    export default {
        data() {
            return {
                countUp: '',
            }
        },

        props: {
            start: {
                type: Number,
                default: 0,
            },

            end: {
                required: true,
            },

            duration: {
                type: Number,
                default: 1,
            },

            decimals: {
                type: Number,
                default: 0
            },

            easing: {
                type: Boolean,
                default: true,
            },

            grouping: {
                type: Boolean,
                default: true,
            },

            separator: {
                type: String,
                default: ','
            },

            decimal: {
                type: String,
                default: '.'
            },

            prefix: {
                type: String,
                default: ''
            },

            suffix: {
                type: String,
                default: ''
            },
        },

        watch: {
            end() {
                this.recount();
            }
        },

        mounted() {
            bus.$on('update-charts', function () {
                this.recount();
            }.bind(this));

            let options = {
                useEasing: this.easing,
                useGrouping: this.grouping,
                separator: this.separator,
                decimal: this.decimal,
                prefix: this.prefix,
                suffix: this.suffix
            }

            this.countUp = new CountUp(this.$el, this.start, this.end, this.decimals, this.duration, options);
            this.countUp.start();
        },

        methods: {
            recount() {
                _.defer(() => {
                    this.countUp.update(this.end);
                })
            }
        }
    }
</script>